/**
 * JWT token utilities for SmartGTD frontend
 */

import { fetchConfig } from '../config';

// Config cache to avoid repeated fetches
let configCache = null;

// Cognito groups
const ADMIN_GROUP = "smartgtd-admins";
const POWER_USER_GROUP = "smartgtd-power-users";
const USER_GROUP = "smartgtd-users";

/**
 * Get current ID token from Cognito SDK storage
 */
export const getIdToken = async () => {
  if (!configCache) {
    configCache = await fetchConfig();
  }
  const keyPrefix = `CognitoIdentityServiceProvider.${configCache.cognito.clientId}`;
  const lastAuthUser = localStorage.getItem(`${keyPrefix}.LastAuthUser`);
  return lastAuthUser ? localStorage.getItem(`${keyPrefix}.${lastAuthUser}.idToken`) : null;
};

/**
 * Decode JWT token payload (without verification - for client-side use only)
 */
export const decodeJWT = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Failed to decode JWT:', error);
    return null;
  }
};

/**
 * Get user permissions from JWT token
 */
export const getUserPermissions = async () => {
  const token = await getIdToken();
  if (!token) return { role: 'user', can_edit_prompt: false, can_change_model: false };

  const payload = decodeJWT(token);
  if (!payload) return { role: 'user', can_edit_prompt: false, can_change_model: false };

  const groups = payload['cognito:groups'] || [];
  
  const role = groups.includes(ADMIN_GROUP) ? 'admin' 
    : groups.includes(POWER_USER_GROUP) ? 'power_user' 
    : 'user';

  return {
    role,
    groups,
    can_edit_prompt: groups.includes(ADMIN_GROUP),
    can_change_model: groups.includes(ADMIN_GROUP) || groups.includes(POWER_USER_GROUP),
    allowed_models: payload['custom:allowed_models']?.split(',') || ['claude-3-haiku']
  };
};
